<div class="request form-frame">
  <app-logo></app-logo>

  <div class="form-frame__body">
    <img src="assets/img/ok.svg" alt="OK" class="form-frame__body-icon">
    <h2
      class="form-frame__body-title">
      {{'REQUEST_SEND_PAGE.TITLE' | translate}}
    </h2>
    <p
      class="form-frame__body-description">
      {{'REQUEST_SEND_PAGE.DESCRIPTION' | translate}}
    </p>
    <button
      routerLink="/login"
      class="btn btn-accent">
      {{'REQUEST_SEND_PAGE.BUTTON' | translate}}
    </button>
  </div>

  <app-lang-select></app-lang-select>
</div>
